import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class SearchResultsCacheService {

  private record: any;
  private searchFilters: any;
  private results: any[];
  private totalResults: number = 0;
  private startIndex: number = 0;
  private endIndex: number = 0;
  private pageIndex: number = 0;
  private resultsPerPage: number = 10;
  private lastSearchResult: any;
  private visitedLastPageFirst: boolean = false;
  private lastUnvisitedSearchResult: any;
  private visitedResults: any[] = [];

  constructor() { }

  public setRecord(record: any) {
    localStorage.setItem("record", JSON.stringify(record));
  } 

  public getRecord(): any {
    return localStorage.getItem("record");
  }

  public setForm(searchFilters: any): void {
    this.searchFilters = searchFilters;
  }

  public getForm(): any {
    return this.searchFilters;
  }

  public setResults(results: any): void {
    this.results = results;
  }

  public getResults(): any[] {
    return this.results;
  }

  public setTotalResults(totalResults: number): void {
    this.totalResults = totalResults;
  }

  public getTotalResults(): number {
    return this.totalResults;
  }

  public setStartIndex(startIndex: number): void {
    this.startIndex = startIndex;
  }

  public getStartIndex(): number {
    return this.startIndex;
  }

  public setEndIndex(endIndex: number): void {
    this.endIndex = endIndex;
  }

  public getEndIndex(): number {
    return this.endIndex;
  }

  public setPageIndex(pageIndex: number): void {
    this.pageIndex = pageIndex;
  }

  public getPageIndex(): number {
    return this.pageIndex;
  }

  public setResultsPerPage(resultsPerPage: number): void {
    this.resultsPerPage = resultsPerPage;
  }

  public getResultsPerPage(): number {
    return this.resultsPerPage;
  }

  public setLastSearchResult(lastSearchResult: any): void {
    this.lastSearchResult = lastSearchResult;
  }

  public getLastSearchResult(): any {
    return this.lastSearchResult;
  }

  public setVisitedLastPageFirst(visitedLastPageFirst: boolean): void {
    this.visitedLastPageFirst = visitedLastPageFirst;
  }

  public getVisitedLastPageFirst(): boolean {
    return this.visitedLastPageFirst;
  }

  public setLastUnvisitedSearchResult(lastUnvisitedSearchResult: any): void {
    this.lastUnvisitedSearchResult = lastUnvisitedSearchResult;
  }

  public getLastUnvisitedSearchResult(): any {
    return this.lastUnvisitedSearchResult;
  }

  public setVisitedResults(visitedResults: any[]): void {
    this.visitedResults = visitedResults;
  }

  public getVisitedResults(): any[] {
    return this.visitedResults;
  }

  clear() {
    this.record = undefined;
    this.searchFilters = undefined;
    this.results = [];
    this.totalResults = 0;
    this.startIndex = 0;
    this.endIndex = 0;
    this.pageIndex = 0;
    this.resultsPerPage = 10;
    this.lastSearchResult = undefined;
    this.visitedLastPageFirst = false;
    this.lastUnvisitedSearchResult = undefined;
    this.visitedResults = [];
  }
}